<template>
    <div>
        <template v-if="!loading">
            <sale-info v-if="open === 'info'" :sale="sale" @closeChild="onCloseChild"></sale-info>
            <messages v-else-if="open === 'messages'" :sale="sale" @closeChild="onCloseChild"></messages>
            <banners v-else-if="open === 'banners'" :sale="sale" :urls="urls" @closeChild="onCloseChild"></banners>
            <stickers v-else-if="open === 'stickers'" :sale="sale" @closeChild="onCloseChild"></stickers>
            <countdowns v-else-if="open === 'countdowns'" :sale="sale" @closeChild="onCloseChild"></countdowns>
            <discounts v-else-if="open === 'discounts'" :sale="sale" @closeChild="onCloseChild"></discounts>
            <table class="table table-striped" v-else>
                <thead>
                    <tr>
                        <th scope="col">Section</th>
                        <th scope="col">Info</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th class="align-middle">Sale Info <small>*required</small></th>
                        <td>
                            <div>
                                <span class="font-weight-bold">Name:</span> {{ sale.name }}
                            </div>
                            <template>
                                <div v-if="sale.starts_at != null && sale.ends_at != null">
                                    <span class="font-weight-bold">From:</span> {{ readable_date(sale.starts_at) }}
                                </div>
                                <div>
                                    <span class="font-weight-bold">To:</span> {{ readable_date(sale.ends_at) }}
                                </div>
                            </template>
                            <div v-for="website in sale.websites">
                                <span class="font-weight-bold">Website:</span> {{ website.name }}
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1" @click="open = 'info'"><i class="far fa-edit"></i>&nbsp; Edit</button>
                        </td>
                    </tr>
                    <tr>
                        <th class="align-middle">Messages</th>
                        <td>
                            <div v-if="sale.messages.length > 0">
                                <span class="font-weight-bold">{{sale.messages.length}}</span> message(s)
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1"
                            v-if="sale.messages.length > 0" @click="open = 'messages'">
                                <i class="far fa-edit"></i>&nbsp; Edit
                            </button>
                            <button type="button" class="btn btn-success btn-sm mr-1" v-else @click="open = 'messages'"><i class="fas fa-plus"></i>&nbsp; Add</button>
                        </td>
                    </tr>
                    <!-- Blinds Direct IE's site doesn't use the sale's banners or stickers (its homepage hero
                         takes the Home Banner message, its badges the discount in the sale bar's colours) -->
                    <tr v-if="!bdie">
                        <th class="align-middle">Banners</th>
                        <td>
                            <div v-if="sale.banners.length > 0">
                                <span class="font-weight-bold">{{sale.banners.length}}</span> banner(s)
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1"
                            v-if="sale.banners.length > 0" @click="open = 'banners'">
                                <i class="far fa-edit"></i>&nbsp; Edit
                            </button>
                            <button type="button" class="btn btn-success btn-sm mr-1" v-else @click="open = 'banners'"><i class="fas fa-plus"></i>&nbsp; Add</button>
                        </td>
                    </tr>
                    <tr v-if="!bdie">
                        <th class="align-middle">Stickers</th>
                        <td>
                            <div v-if="sale.stickers.length > 0">
                                <span class="font-weight-bold">{{sale.stickers.length}}</span> sticker(s)
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1"
                            v-if="sale.stickers.length > 0" @click="open = 'stickers'">
                                <i class="far fa-edit"></i>&nbsp; Edit
                            </button>
                            <button type="button" class="btn btn-success btn-sm mr-1" v-else @click="open = 'stickers'"><i class="fas fa-plus"></i>&nbsp; Add</button>
                        </td>
                    </tr>
                    <tr>
                        <th class="align-middle">Countdowns</th>
                        <td>
                            <div v-for="countdown in sale.countdowns">
                                <span class="font-weight-bold">From:</span> {{readable_date(countdown.starts_at)}} <span class="font-weight-bold">To:</span> {{readable_date(countdown.ends_at)}}
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1"
                            v-if="sale.countdowns.length > 0" @click="open = 'countdowns'">
                                <i class="far fa-edit"></i>&nbsp; Edit
                            </button>
                            <button type="button" class="btn btn-success btn-sm mr-1" v-else @click="open = 'countdowns'"><i class="fas fa-plus"></i>&nbsp; Add</button>
                        </td>
                    </tr>
                    <tr>
                        <th class="align-middle">Discount (inc delivery thresholds)</th>
                        <td>
                            <div v-if="sale.discounts.length > 0">
                                <span class="font-weight-bold">{{sale.discounts.length}}</span> discount<template v-if="sale.discounts.length > 1">s</template>
                            </div>
                            <div v-if="sale.delivery_thresholds.length > 0">
                                <span class="font-weight-bold">{{sale.delivery_thresholds.length}}</span> delivery threshold<template v-if="sale.delivery_thresholds.length > 1">s</template>
                            </div>
                            <div v-if="sale.order_total_thresholds.length > 0">
                                <span class="font-weight-bold">{{sale.order_total_thresholds.length}}</span> order total threshold<template v-if="sale.order_total_thresholds.length > 1">s</template>
                            </div>
                        </td>
                        <td>
                            <button type="button" class="btn btn-primary btn-sm mr-1"
                            v-if="sale.discounts.length > 0 || sale.delivery_thresholds.length > 0" @click="open = 'discounts'">
                                <i class="far fa-edit"></i>&nbsp; Edit
                            </button>
                            <button type="button" class="btn btn-success btn-sm mr-1" v-else @click="open = 'discounts'"><i class="fas fa-plus"></i>&nbsp; Add</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <loader :loading="loading"></loader>
    </div>
</template>

<script>

import moment from 'moment';
import saleInfo from './saleInfo.vue';
import messages from './messages.vue';
import banners from './banners.vue';
import stickers from './stickers.vue';
import countdowns from './countdowns.vue';
import discounts from './discounts.vue';
import loader from './loader';

export default {

    components: {
        moment,
        saleInfo,
        messages,
        banners,
        stickers,
        countdowns,
        discounts,
        loader,
    },

    props: {
        sale_info: Object,
        urls: Array
    },

    data() {
        return {
            open: false,
            loading: true,
            sale: {},
        };
    },

    computed: {
        // a Blinds Direct IE sale (website 118): no banners / stickers sections
        bdie(){
            return (this.sale.websites || []).some(website => website.id == 118);
        },
    },

    mounted(){
        //load edit section based on page param in url query
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.get('page')){
            this.open = urlParams.get('page');
        }
        this.reload_sale();
    },

    methods: {
        readable_date: function (date) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        },
        onCloseChild (value) {
            this.open = value;
            this.reload_sale();
        },
        reload_sale(){
            this.loading = true;
            axios.get('/sales/' + this.sale_info.id)
            .then(function (response) {
                this.sale = response.data.sale;
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                alert(error);
            })
        }
    },
};
</script>
